<template>
    <div class="app">
        <scroll>
            <section>
                <dl class="field" style="height: 65px">
                    <span class="f-strong f-middle">订单号：{{ orderId }}</span>
                    <dd class="right-item f-strongest f-largest">{{ fee | formatFee }}</dd>
                </dl>
            </section>
            <section v-show="paySuccess" class="pay-success-bg">
                <div class="success-photo"></div>
                <label class="f-largest">支付成功</label>
            </section>
            <section v-show="payFailed" class="pay-success-bg">
                <div class="failed-photo"></div>
                <label class="f-largest">支付失败</label>
            </section>
            <section v-show="payOvertime" class="pay-success-bg">
                <div class="failed-photo"></div>
                <label class="f-largest">网络错误，请稍后重试</label>
            </section>
        </scroll>
        <footer>
            <button class="btn-finished" v-show="paySuccess || payOvertime" @click="finished(true)">完成</button>
            <button class="btn-finished" v-show="payFailed" @click="finished(false)">完成</button>
        </footer>
    </div>
</template>
<script>

    export default {
        data(){
            return {
                fee: '0',
                orderId: '0',
                cardType: '',
                cardNo: '',
                startDate: '',
                endDate: '',
                busiType: '',
                pay: {},
                payFailed: false,
                paySuccess: false,
                payOvertime: false,
                paySuccessInfo: {},
            }
        },
        /*eslint-disable*/
        mounted(){
            //在加载界面前，获取请求头所需要的参数信息
            //获取当前的channel
            //判断是否为天府云渠道,因为从微信回到天府云以后，localStorage里面没有了channel
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                localStorage.channel = "WX";
                //获取上级传入参数
                this.paySuccessInfo = this.$store.state.paramModule.param.paySuccess.paySuccessInfo;
            } else {
                if(ua.indexOf("tftb_hanweb") > -1) {
                    localStorage.setItem('channel', 'TFTB')
                } else if(ua.indexOf("tfryb_hanweb") > -1) {
                    localStorage.setItem('channel', 'TFRYB')
                } else {
                    localStorage.setItem('channel', 'TFY')
                }
                // 0元缴费特殊处理
                if (this.$store.state.paramModule.param.paySuccess && parseFloat(this.$store.state.paramModule.param.paySuccess.paySuccessInfo.fee) === 0) {
                    this.paySuccessInfo = this.$store.state.paramModule.param.paySuccess.paySuccessInfo;
                } else {
                    // 重新获取tokenId
                    const query = this.$router.currentRoute.query;
                    this.paySuccessInfo = query;
                    // 由于请求头执行一次以后不会再次执行，需要手动替换该请求头才能生效
                    localStorage.tokenId = query.token || localStorage.tokenId
                    window.http.headers.common['tokenId'] = localStorage.tokenId
                    window.http.headers.common['channel'] = localStorage.channel || 'WX'
                }
            }
            this.fee = this.paySuccessInfo.fee;
            this.orderId = this.paySuccessInfo.orderId;
            this.busiType = this.paySuccessInfo.busiType;
            this.refresh();
        },
        methods: {

            //同步订单轮询
            syncOrder : function(){
                this.$http.get('/app/pay/sync/{orderId}', {
                    params: {
                        orderId: this.orderId,
                    },
                    withoutLoading:false
                }).then(res => {
                    //返回结果成功
                    if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
                        if (res.data.data.orderStatus === this.constant.ORDER_STATUS.ABLE_PAYMENT){
                            //结束轮询
                            this.$utils.loaded();
                            this.paySuccess = true;
                            return;
                        } else if (res.data.data.orderStatus === this.constant.ORDER_STATUS.UNABLE_PAYMENT || res.data.data.orderStatus === this.constant.ORDER_STATUS.UNABLE_RETURN_FEE){
                            //继续轮询
                            setTimeout(() =>{
                                this.syncOrder();
                            }, 500);
                        } else {
                            //结束轮询
                            this.$utils.loaded();
                            this.payFailed = true;
                            return;
                        }
                    } else if (res.data.resultCode === '20050006') {
                        this.$utils.loaded();
                        this.payOvertime = true;
                        return;
                    } else {
                        //结束轮询
                        this.$utils.loaded();
                        this.payFailed = true;
                        return;
                    }
                }, ()=> {
                    this.payFailed = true;
                })
            },
            refresh() {
                this.$utils.loading(0);
                //轮询后台返回结果
                setTimeout(() =>{
                    this.syncOrder();
                }, 1000);
            },

            //跳转缴费详情或挂号详情
            finished(flag){
                localStorage.setItem('payResult', JSON.stringify({result:flag, busiType: this.busiType}))
                //判断是否为天府云渠道
                if (localStorage.channel === 'TFY' || localStorage.channel === 'TFTB' || localStorage.channel === 'TFRYB') {
                    if (flag === false) {
                        // this.$router.go(1 - history.length)
                        this.$router.replace('/');
                    } else {
                        this.$router.go(2 - history.length)
                    }
                } else {
                    this.$router.go(1 - history.length)
                    setTimeout( () =>{
                        if(location.href.indexOf('paySuccess') > 0){
                            this.$router.go(2 - history.length)
                        }
                    },500)
                }
            }
        }
    }
</script>

<style lang="scss">
    .pay-success-bg {
        top: 3.8rem;
        right: 0rem;
        bottom: 0rem;
        left: 0rem;
        background-color: white;
        position: absolute;
        text-align: center
    }
</style>



// WEBPACK FOOTER //
// PaySuccess.vue?55e9b5ac